import AdminNavbar from './AdminNavbar'
export default AdminNavbar;